export type SupportRequestCategory =
  | "how_to_use"
  | "documents"
  | "account"
  | "bug"
  | "feature"
  | "other";

export type SubmitSupportRequestParams = {
  message: string;
  category: SupportRequestCategory;
  municipalityId?: number;
  source?: string;
};

export async function submitSupportRequest(params: SubmitSupportRequestParams): Promise<void> {
  const csrfToken = document.querySelector("meta[name='csrf-token']")?.getAttribute("content") ?? "";

  const response = await fetch("/api/v1/support_requests", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-Token": csrfToken,
      Accept: "application/json",
    },
    credentials: "include",
    body: JSON.stringify({
      support_request: {
        message: params.message,
        category: params.category,
        municipality_id: params.municipalityId,
        source: params.source ?? "launch_pad",
      },
    }),
  });

  if (!response.ok) {
    const payload = await response.json().catch(() => ({}));
    const message =
      typeof payload.message === "string" ? payload.message : `Request failed with ${response.status}`;
    throw new Error(message);
  }
}

export const SUPPORT_REQUEST_CATEGORIES: { value: SupportRequestCategory; label: string }[] = [
  { value: "how_to_use", label: "How to use Ordinal" },
  { value: "documents", label: "Documents & uploads" },
  { value: "account", label: "Account & access" },
  { value: "bug", label: "Something isn't working" },
  { value: "feature", label: "Feature idea" },
  { value: "other", label: "Other" },
];

export const SUPPORT_PORTAL_URL = "https://www.ordinalforgov.com/support";
